export default "__VITE_ASSET__BVmItF$U__"